import { Fragment, ReactNode } from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { ProposalObservation } from "../../../../../../../../app/services/transactionService/transactionById";

type ObservationsHistoryProps = {
  observations: ProposalObservation[];
};

const URL_SPLIT_REGEX = /(https?:\/\/[^\s]+)/g;
const IS_URL_REGEX = /^https?:\/\//;

const formatObservationDate = (date: string) => {
  if (!date) return "";

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return date;

  return `${format(parsed, "EEEEEE, dd MMM yyyy", { locale: ptBR })} · ${format(
    parsed,
    "HH:mm",
  )}`;
};

const linkify = (text: string): ReactNode[] =>
  text.split(URL_SPLIT_REGEX).map((part, index) => {
    if (!IS_URL_REGEX.test(part))
      return <Fragment key={index}>{part}</Fragment>;

    return (
      <a
        key={index}
        href={part}
        target="_blank"
        rel="noreferrer"
        className="break-all text-info hover:underline"
      >
        {part.replace(IS_URL_REGEX, "")}
      </a>
    );
  });

export const ObservationsHistory = ({
  observations,
}: ObservationsHistoryProps) => {
  return (
    <div className="w-full">
      <p className="py-5 font-semibold text-black03">
        Histórico de observações
      </p>

      <ul className="rounded-xl border border-[#D5D8DE] p-5 pb-3">
        {observations.map((observation, index) => {
          const isLast = index === observations.length - 1;

          return (
            <li
              key={`${observation.dataObservacao}-${index}`}
              className="relative pb-5 pl-5"
            >
              {!isLast && (
                <span
                  aria-hidden
                  className="absolute bottom-[-6px] left-[3px] top-3 w-px bg-[#D9DCE1]"
                />
              )}
              <span
                aria-hidden
                className={`absolute left-0 top-[6px] h-[7px] w-[7px] rounded-full ${
                  isLast ? "bg-black03" : "bg-[#C4C9D0]"
                }`}
              />

              <p className="mb-1 text-xs font-medium text-black04">
                {formatObservationDate(observation.dataObservacao)}
              </p>
              <p className="whitespace-break-spaces text-xs font-semibold text-black03">
                {linkify(observation.observacao)}
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
